import { inject } from '@angular/core';
import { HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { AccountService } from '@app/_services';

export function errorInterceptor(request: HttpRequest<any>, next: HttpHandlerFn) {
    const accountService = inject(AccountService);
    const router = inject(Router);

    return next(request).pipe(catchError(err => {
        if ([401, 403].includes(err.status)) {
            // auto logout if 401 or 403 response returned from api
            if (accountService.userValue)
                accountService.logout().subscribe(() => 
                    window.location.href = '/account/logout?redirect_url=' + router.routerState.snapshot.url);
        }

        const message = err.error?.message || err.error; // || err.message || err;
        //console.error(JSON.stringify(err));
        return throwError(() => message);
    }))
}
